import { render, staticRenderFns } from "./medicalInvoice.vue?vue&type=template&id=15519ed1&scoped=true"
import script from "./medicalInvoice.vue?vue&type=script&lang=js"
export * from "./medicalInvoice.vue?vue&type=script&lang=js"
import style0 from "./medicalInvoice.vue?vue&type=style&index=0&id=15519ed1&prod&lang=css"
import style1 from "./medicalInvoice.vue?vue&type=style&index=1&id=15519ed1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15519ed1",
  null
  
)

export default component.exports